import { Action, handleActions } from 'redux-actions'
import {
  CompanyId,
  DivisionId,
  DivisionRow,
  DivisionDto,
  GetAssignRandomTeamsFilters$Response,
  DeleteTeams$Request,
  DivisionCategoryRow,
  DivisionCategoryId,
} from '../../../services/api.types'
import {
  createTeam,
  createTeamSuccess,
  createTeamFail,
  createTeamLoading,
  deleteTeamsSuccess,
  getCompanyTeams,
  getCompanyTeamsFail,
  getCompanyTeamsSuccess,
  /*getDivisionsDeprecated,
  getDivisionsFail,
  getDivisionsSuccess,*/
  lockTeamsSuccess,
  setSelectedGroupId,
  setSelectedGroupIdForCompany,
  setSelectedGroupIdForCategory,
  unlockTeamsSuccess,
  updateTeamSettingsFail,
  updateTeamSettingsSuccess,
  updateDivisionCategorySettingsSuccess,
  updateDivisionCategorySettingsFail,
  generateTeams,
  generateTeamsSuccess,
  generateTeamsFail,
  assignTeamsRandomly,
  assignTeamsRandomlySuccess,
  assignTeamsRandomlyFail,
  getAssignRandomTeamsFilters,
  getAssignRandomTeamsFiltersSuccess,
  getAssignRandomTeamsFiltersFail,
  deleteTeams,
  deleteTeamsFail,
  deleteTeamsLoading,
  renameTeam,
  renameTeamSuccess,
  renameTeamFail,
  setCreatedDivisionId,
  resetCreateTeamLoading,
  getDivisionCategories,
  getDivisionCategoriesSuccess,
  getDivisionCategoriesFail,
  createDivisionCategory,
  createDivisionCategorySuccess,
  createDivisionCategoryFail,
  deleteDivisionCategory,
  deleteDivisionCategorySuccess,
  deleteDivisionCategoryFail,
  createGroupSuccess,
} from './TeamManagementActions'

class State {
  companyTeams: DivisionRow[] = []
  teamsLoading = false
  deleteTeamsLoading: CompanyId | null = null
  selectedGroupId: DivisionCategoryId | null = null
  selectedGroupIdPerCompany: { [companyId: string]: DivisionCategoryId | null } = {}
  createdDivisionId: DivisionId = null
  createdGroupId: { [categoryId: string]: DivisionId } = {}
  deletedDivisionIds: DivisionId[] = []
  lastUpdatedTeamSettings: number | null = null
  lastTeamSettingsFail: number | null = null
  lastUpdatedDivisionCategorySettings: number | null = null
  lastDivisionCategorySettingsFail: number | null = null
  lastTeamsUpdate: number | null = null
  createTeamLoading: CompanyId | null = null
  renameTeamFailed = false
  assignRandomTeamsFilters: {
    loading: boolean
    data: GetAssignRandomTeamsFilters$Response | null
  } = {
    loading: false,
    data: null,
  }
  divisionCategories: DivisionCategoryRow[] = []
  groupsLoading = false
  selectedGroupIdsPerCategory: { [categoryId: string]: DivisionId | null } = {}

  // Deprecated
  companyGroups: { [companyId: string]: { [categoryId: string]: DivisionRow[] } } = {}
}

export const teamManagement = handleActions<State, any>(
  {
    [String(getCompanyTeams)]: (state: State): State => ({
      ...state,
      companyTeams: [],
      teamsLoading: true,
    }),
    [String(getCompanyTeamsSuccess)]: (state: State, action: Action<DivisionRow[]>): State => {
      return {
        ...state,
        companyTeams: action.payload,
        teamsLoading: false,
      }
    },
    [String(getCompanyTeamsFail)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),
    /*[String(getDivisionsDeprecated)]: (state: State): State => ({
      ...state,
      companyTeams: [],
      teamsLoading: true,
    }),
    [String(getDivisionsSuccess)]: (
      state: State,
      action: Action<{ companyId: string; categoryId: string; groups: DivisionRow[] }>,
    ): State => {
      const { companyId, categoryId, groups } = action.payload

      // Categorize groups by their own categoryId property
      const categorizedGroups = groups.reduce(
        (acc, group) => {
          if (!acc[group.categoryId]) {
            acc[group.categoryId] = []
          }
          acc[group.categoryId].push(group)
          return acc
        },
        {} as Record<string, DivisionRow[]>,
      )
      // console.log('categorizedGroups:', categorizedGroups)

      return {
        ...state,
        companyGroups: {
          ...state.companyGroups,
          [companyId]: categorizedGroups,
        },
        teamsLoading: false,
      }
    },
    [String(getDivisionsFail)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),*/
    [String(createTeam)]: (state: State): State => ({
      ...state,
    }),
    [String(createTeamLoading)]: (state: State, action: Action<CompanyId | null>): State => ({
      ...state,
      createTeamLoading: action.payload,
    }),
    [String(createTeamSuccess)]: (state: State, action: Action<DivisionId>): State => ({
      ...state,
      createdDivisionId: action.payload,
      createTeamLoading: null,
      lastTeamsUpdate: new Date().getTime(),
    }),
    [String(createGroupSuccess)]: (state: State, action: Action<DivisionId>): State => ({
      ...state,
      createdDivisionId: action.payload, // Set createdDivisionId so modal closes after group creation
      //createdGroupId: action.payload,
      createTeamLoading: null,
      lastTeamsUpdate: new Date().getTime(),
    }),
    // [String(setCreatedGroupId)]: (state: State, action: Action<DivisionId>): State => ({
    //   ...state,
    //   createdGroupId: {
    //     ...state.createdGroupId,
    //     [action.payload.categoryId]: action.payload.divisionId,
    //   },
    // }),
    [String(createTeamFail)]: (state: State): State => ({
      ...state,
      createTeamLoading: null,
    }),
    [String(renameTeam)]: (state: State): State => ({
      ...state,
      renameTeamFailed: false,
    }),
    [String(renameTeamSuccess)]: (state: State): State => ({
      ...state,
      renameTeamFailed: false,
      lastTeamsUpdate: new Date().getTime(),
    }),
    [String(renameTeamFail)]: (state: State): State => ({
      ...state,
      renameTeamFailed: true,
      lastTeamsUpdate: new Date().getTime(),
    }),
    [String(generateTeams)]: (state: State): State => ({
      ...state,
      teamsLoading: true,
    }),
    [String(generateTeamsSuccess)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),
    [String(generateTeamsFail)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),
    [String(assignTeamsRandomly)]: (state: State): State => ({
      ...state,
      teamsLoading: true,
    }),
    [String(assignTeamsRandomlySuccess)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),
    [String(assignTeamsRandomlyFail)]: (state: State): State => ({
      ...state,
      teamsLoading: false,
    }),
    [String(getAssignRandomTeamsFilters)]: (state: State): State => ({
      ...state,
      assignRandomTeamsFilters: {
        ...state.assignRandomTeamsFilters,
        loading: true,
      },
    }),
    [String(getAssignRandomTeamsFiltersSuccess)]: (
      state: State,
      action: Action<GetAssignRandomTeamsFilters$Response>,
    ): State => ({
      ...state,
      assignRandomTeamsFilters: {
        loading: false,
        data: action.payload,
      },
    }),
    [String(getAssignRandomTeamsFiltersFail)]: (state: State): State => ({
      ...state,
      assignRandomTeamsFilters: {
        ...state.assignRandomTeamsFilters,
        loading: false,
      },
    }),
    [String(setSelectedGroupId)]: (state: State, action: Action<DivisionCategoryId | null>): State => ({
      ...state,
      selectedGroupId: action.payload,
    }),
    [String(setSelectedGroupIdForCompany)]: (
      state: State,
      action: Action<{ companyId: string; groupId: string | null }>,
    ): State => ({
      ...state,
      selectedGroupIdPerCompany: {
        ...state.selectedGroupIdPerCompany,
        [action.payload.companyId]: action.payload.groupId,
      },
    }),
    [String(setSelectedGroupIdForCategory)]: (
      state: State,
      action: Action<{ categoryId: string; groupId: DivisionId | null }>,
    ): State => ({
      ...state,
      selectedGroupIdsPerCategory: {
        ...state.selectedGroupIdsPerCategory,
        [action.payload.categoryId]: action.payload.groupId,
      },
    }),
    [String(setCreatedDivisionId)]: (state: State, action: Action<DivisionId>): State => ({
      ...state,
      createdDivisionId: action.payload,
    }),
    [String(deleteTeams)]: (state: State, action: Action<DeleteTeams$Request & { companyId?: CompanyId }>): State => ({
      ...state,
      deleteTeamsLoading: action.payload.companyId || null,
    }),
    [String(deleteTeamsSuccess)]: (state: State, action: Action<DivisionId[]>): State => ({
      ...state,
      deleteTeamsLoading: null,
      createdDivisionId: null,
      deletedDivisionIds: action.payload,
    }),
    [String(deleteTeamsFail)]: (state: State): State => ({
      ...state,
      deleteTeamsLoading: null,
    }),
    [String(deleteTeamsLoading)]: (state: State, action: Action<CompanyId | null>): State => ({
      ...state,
      deleteTeamsLoading: action.payload,
    }),
    [String(updateTeamSettingsSuccess)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastUpdatedTeamSettings: action.payload,
    }),
    [String(updateTeamSettingsFail)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastTeamSettingsFail: action.payload,
    }),
    [String(updateDivisionCategorySettingsSuccess)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastUpdatedDivisionCategorySettings: action.payload,
    }),
    [String(updateDivisionCategorySettingsFail)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastDivisionCategorySettingsFail: action.payload,
    }),
    [String(lockTeamsSuccess)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastTeamsUpdate: action.payload,
    }),
    [String(unlockTeamsSuccess)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastTeamsUpdate: action.payload,
    }),
    [String(resetCreateTeamLoading)]: (state: State): State => ({
      ...state,
      createTeamLoading: null,
      deleteTeamsLoading: null,
    }),
    // [String(getDivisionCategories)]: (state: State): State => ({
    //   ...state,
    //   divisionCategories: [],
    //   groupsLoading: true,
    // }),
    [String(getDivisionCategoriesSuccess)]: (state: State, action: Action<DivisionCategoryRow[]>): State => ({
      ...state,
      divisionCategories: action.payload,
      groupsLoading: false,
    }),
    [String(getDivisionCategoriesFail)]: (state: State): State => ({
      ...state,
      groupsLoading: false,
    }),
    [String(createDivisionCategory)]: (state: State): State => ({
      ...state,
      groupsLoading: true,
    }),
    [String(createDivisionCategorySuccess)]: (state: State): State => ({
      ...state,
      groupsLoading: false,
    }),
    [String(createDivisionCategoryFail)]: (state: State): State => ({
      ...state,
      groupsLoading: false,
    }),
    [String(deleteDivisionCategory)]: (state: State): State => ({
      ...state,
      groupsLoading: true,
    }),
    [String(deleteDivisionCategorySuccess)]: (state: State): State => ({
      ...state,
      groupsLoading: false,
    }),
    [String(deleteDivisionCategoryFail)]: (state: State): State => ({
      ...state,
      groupsLoading: false,
    }),
  },
  new State(),
)

export { State as TeamManagementState }
